@let obs =
  {
    menuItems: menuItems$ | async,
  };

@for (item of obs.menuItems; track item.id) {
  <a [routerLink]="item.url" [target]="item.target" class="link" routerLinkActive="active">
    <span>{{ item.title }}</span>

    @if (item.isBonusItem) {
      <sd-bonus-widget [amount]="item.bonusBalance"></sd-bonus-widget>
    }

    @if (item.icon) {
      <img [src]="item.icon.url" class="icon-size-s" [alt]="item.icon.altText" />
    }
  </a>
}
